//imports
import { all } from 'redux-saga/effects';

//Views
import createEditEventSagas from 'Modules/events/views/.components/createEditEvent/redux/saga';
import deleteEventSagas from 'Modules/events/views/.components/deleteEvent/redux/saga';
import unitTypeEventsSagas from 'Modules/events/.components/unitTypeEvents/redux/saga';
import createEditUnitTypeEventSagas from 'Modules/events/.components/createEditUnitTypeEvent/redux/saga';
import deleteUnitTypeEventSagas from 'Modules/events/.components/deleteUnitTypeEvent/redux/saga';


//merge sagas
export default function* rootSaga() {
    yield all([
        createEditEventSagas(),
        deleteEventSagas(),
        unitTypeEventsSagas(),
        createEditUnitTypeEventSagas(),
        deleteUnitTypeEventSagas(),
    ]);
}